import React from 'react';

/** Full-page marketing landing (Claude artifact bundle in public/landing-page.html). */
const HomeLandingView: React.FC = () => (
  <iframe
    src="/landing-page.html"
    title="Ruby Oncology"
    className="fixed inset-0 w-full h-full border-0 block"
  />
);

export default HomeLandingView;
